export default __webpack_public_path__ + "static/media/actions-compass.d0eafb32.svg";